import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { avatarStyle, initialsOf, prettyType } from "./format";

const MAX_BRANCHES = 6;

const EmployeeCard = ({ employee: e, showFingerprint }) => {
  const [copied, setCopied] = useState(false);
  const [allBranches, setAllBranches] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(e.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1300);
    } catch {
      /* clipboard unavailable */
    }
  };

  const facts = [
    ["Employee code", e.employeeCode],
    ["Department", e.department?.name],
    ["Job title", e.jobTitle?.name],
    ["Phone", e.phone],
    ["Account type", prettyType(e.userType)],
    ...(showFingerprint ? [["Fingerprint ID", e.fingerprint]] : []),
  ];

  // Branch names without the trailing " Branch" word.
  const branches = (e.branches || []).map((b) => String(b.name).replace(/\s+branch$/i, ""));
  const shown = allBranches ? branches : branches.slice(0, MAX_BRANCHES);
  const hidden = branches.length - MAX_BRANCHES;

  return (
    <div className="er-emp">
      <div className="er-row" style={{ gap: 12, padding: "14px 16px", borderBottom: "1px solid var(--line)" }}>
        <div className="er-avatar" style={{ width: 42, height: 42, fontSize: 14, ...avatarStyle(e.name) }}>{initialsOf(e.name)}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 600 }}>{e.name}</div>
          {e.email && (
            <div className="er-row" style={{ gap: 6, fontSize: 12.5, color: "var(--muted)", minWidth: 0 }}>
              <span className="er-ellipsis">{e.email}</span>
              <button
                type="button"
                className="er-btn"
                onClick={copy}
                title="Copy email"
                style={{ width: 22, height: 22, borderRadius: 6, display: "grid", placeItems: "center", color: copied ? "var(--green)" : "var(--muted)", flexShrink: 0 }}
              >
                {copied ? <Check size={12} strokeWidth={2.4} /> : <Copy size={12} />}
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="er-facts">
        {facts.map(([k, v]) => (
          <div className="er-fact" key={k}>
            <small>{k}</small>
            <div title={v || ""}>{v || "—"}</div>
          </div>
        ))}
      </div>
      <div style={{ padding: "12px 16px 14px", borderTop: "1px solid var(--line)", display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ fontSize: 11.5, color: "var(--faint)" }}>Branches · {branches.length}</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
          {branches.length === 0 && <span style={{ fontSize: 12, color: "var(--faint)" }}>—</span>}
          {shown.map((b, i) => <span className="er-tag" key={`${b}-${i}`}>{b}</span>)}
          {hidden > 0 && (
            <button type="button" className="er-btn er-tagmore" onClick={() => setAllBranches((v) => !v)}>
              {allBranches ? "Show less" : `+${hidden} more`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeCard;
